// extracted by mini-css-extract-plugin
module.exports = {"main_page":"News_main_page__3R89R","main_header":"News_main_header__2y0fz","content":"News_content__lSLEb","table_row":"News_table_row__aCumq"};